import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { OptionDelete_OptionListPage_Mutation } from "./mutation";
import { OptionList_OptionListPage_Query } from "../../query/fetch-option-list/query";

type Props = {
	hotelID: string;
};

export const useDeleteOption = ({ hotelID }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { mutationFunc } = useCustomMutation(OptionDelete_OptionListPage_Mutation);

	const onDeleteOption = useCallback(
		async (optionID: string) => {
			if (window.confirm("本当に削除しますか？") === false) return;

			showLoadingScreenCallback();

			const { errors } = await mutationFunc({
				variables: {
					hotelID,
					optionID,
				},
				refetchQueries: [
					{
						query: OptionList_OptionListPage_Query,
						variables: {
							hotelID,
						},
					},
				],
			}).finally(hideLoadingScreenCallback);

			if (!errors) {
				notifyUserEventInfo({
					description: "削除しました",
				});
			}
		},
		[hideLoadingScreenCallback, hotelID, mutationFunc, showLoadingScreenCallback],
	);

	return {
		onDeleteOption,
	};
};
